<template>
  <div class="StatisticalResult">
    <div class="detial-top">
      <div class="detial-top-title">专项资金自查统计</div>
      <blank height="75"> </blank>
      <img src="./img/FIIlogo.svg" alt="" class="detial-top-btn" />
    </div>
    <div class="detial-cont">
      <div class="detial-cont-view">
        <span>按年统计：</span>
        <a-select
          allowClear
          :placeholder="yearsModel + '年度'"
          class="w200 ml10 mr20"
          v-model="queryForm.year"
        >
          <a-select-option
            v-for="item in years"
            :key="item.value"
            :value="item.value"
            >{{ item.label }}</a-select-option
          >
        </a-select>
        <span>按年上报公司统计：</span>
        <a-tree-select
          allowClear
          v-model="queryForm.company"
          class="w200"
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
          :tree-data="treeData"
          placeholder="全部"
          tree-default-expand-all
          :replaceFields="{
            key: 'id',
            value: 'id',
            children: 'treeList',
            title: 'organizationName'
          }"
        >
        </a-tree-select>
        <a-button
          class="ml20"
          type="primary"
          @click="subMit"
          icon="search"
          :loading="loading"
        >
          统计</a-button
        >
      </div>
      <blank height="1"> </blank>
      <div class="detial-cont-view">
        <a-descriptions layout="vertical">
          <a-descriptions-item label="拨款金额总计">
            <span class="money-font"> ￥{{ data.gatheringMoney || 0 }}</span>
          </a-descriptions-item>
          <a-descriptions-item label="拨付金额总计">
            <span class="money-font">
              ￥{{ data.totalMoney || 0 }}</span
            ></a-descriptions-item
          >
          <a-descriptions-item label="结余总计">
            <span class="money-font"> ￥{{ data.surplusMoney || 0 }}</span>
          </a-descriptions-item>
        </a-descriptions>
      </div>
    </div>
  </div>
</template>

<script>
import { SpecialFundsStatistics } from './api/api'
import { mapState, mapActions } from 'vuex'
export default {
  data() {
    return {
      loading: false,
      queryForm: {},
      yearsModel: null,
      years: [],
      data: {}
    }
  },
  created() {
    //获取组织机构
    this.getorganizeListFn()
    this.init()
    this.load()
  },
  computed: {
    ...mapState({
      treeData: (state) => state.app.treeData // 组织机构树
    })
  },
  methods: {
    ...mapActions(['getorganizeListFn']),
    init() {
      // 获取年月列表
      var myDate = new Date()
      this.yearsModel = myDate.getFullYear() //获取当前年
      this.initSelectYear(this.yearsModel)
    },
    initSelectYear(year) {
      this.years = []
      for (let i = 0; i < 20; i++) {
        this.years.push({ value: year - i, label: year - i + '年度' })
      }
    },

    // 拉取列表
    load() {
      this.loading = true
      let params = this.queryForm
      SpecialFundsStatistics(params).then((res) => {
        this.loading = false
        if (res.data.code == 0) {
          this.data = res.data.data
        }
      })
    },
    cancel() {
      //取消
      this.queryForm = {}
    },
    subMit() {
      this.page = 1
      this.load()
    }
  }
}
</script>

<style lang="scss">
.StatisticalResult {
  .detial-top {
    background: #fff;
    padding: 0 50px 20px 50px;
    position: relative;
    .detial-top-title {
      height: 25px;
      color: rgba(56, 56, 56, 1);
      font-size: 18px;
      font-weight: bold;
    }

    .detial-top-btn {
      width: 203px;
      height: 135px;
      position: absolute;
      right: 87px;
      bottom: 20px;
    }
  }
  .detial-cont {
    margin: 24px 16px;
    .detial-cont-view {
      background: #fff;
      padding: 30px;
      .money-font {
        height: 37px;
        color: rgba(0, 0, 0, 0.65);
        font-size: 25px;
        line-height: 37px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/SpecialFundsSelfInspection/StatisticalResult.vue